import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import useStore from '@/stores/sider-menu';
import useSupplierStore from '@/stores/supplier-session';
import Unread from '@/layouts/main-layout/components/unread';
import MenuIcon from '@/layouts/main-layout/components/menu-icon';
import MenuItem from '@/layouts/main-layout/components/menu-item';
import ConpanyIcon from '@/assets/icons/company.svg?react';
import { PagePath } from '@/routes/paths';

export default function SupplierList() {
  const { collapsed, setCollapsed } = useStore();
  const { totalUnreadCount } = useSupplierStore();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive =
    !!matchPath(PagePath.supplier, location.pathname) || !!matchPath(PagePath.supplierDetail, location.pathname);

  const handleClick = () => {
    if (isActive) return;
    setCollapsed(true);
    navigate(PagePath.supplier);
  };

  if (collapsed) {
    return (
      <MenuIcon onClick={handleClick} title="Suppliers" isActive={isActive}>
        <ConpanyIcon />
      </MenuIcon>
    );
  }

  return (
    <MenuItem className={isActive ? 'bg-[#E5E5E5]/65' : ''} icon={<ConpanyIcon />} onClick={handleClick}>
      <div className="flex items-center justify-between">
        <span>Suppliers</span>
        <Unread count={totalUnreadCount} className="flex-none" />
      </div>
    </MenuItem>
  );
}
